export const products = [
    {
        id: 1,
        title: "Product title",
        name: "Produttori del Barbaresco",
        image: "/assets/images/bottle-1.webp",
        thumbs: [
            "/assets/images/product-01.jpg",
            "/assets/images/product-detail-02.jpg",
            "/assets/images/product-detail-03.jpg"
        ],
        price: 16.64,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L", "1L", "1.5L"
        ],
        color: [
            "Red", "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg <br />
            Dimensions 110 x 33 x 100 cm <br />
            Materials 60% cotton <br />
            Color Black, Blue, Grey, Green, Red, White <br />
            Size XL, L, M, S <br />
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
    {
        id: 2,
        name: "del Poggio Moscato d\"Asti",
        image: "/assets/images/bottle-2.webp",
        thumbs: [
            "/assets/images/product-02.jpg",
            "/assets/images/product-detail-05.jpg",
            "/assets/images/product-detail-06.jpg"
        ],
        price: 8.12,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L"
        ],
        color: [
            "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg <br />
            Dimensions 110 x 33 x 100 cm <br />
            Materials 60% cotton <br />
            Color Black, Blue, Grey, Green, Red, White <br />
            Size XL, L, M, S <br />
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
    {
        id: 3,
        name: "Cantina Beato Bartolomeo Pinot",
        image: "/assets/images/bottle-3.webp",
        thumbs: [
            "/assets/images/product-03.jpg",
            "/assets/images/product-detail-01.jpg",
            "/assets/images/product-detail-02.jpg"
        ],
        price: 16.64,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L", "1L"
        ],
        color: [
            "Red", "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg <br />
            Dimensions 110 x 33 x 100 cm <br />
            Materials 60% cotton <br />
            Color Black, Blue, Grey, Green, Red, White <br />
            Size XL, L, M, S <br />
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
    {
        id: 4,
        name: "Bouvet Saphir 2018",
        image: "/assets/images/bottle-4.webp",
        thumbs: [
            "/assets/images/product-04.jpg",
            "/assets/images/product-detail-02.jpg",
            "/assets/images/product-detail-03.jpg"
        ],
        price: 16.64,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L", "1L", "2L"
        ],
        color: [
            "Red", "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg <br />
            Dimensions 110 x 33 x 100 cm <br />
            Materials 60% cotton <br />
            Color Black, Blue, Grey, Green, Red, White <br />
            Size XL, L, M, S <br />
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
    {
        id: 5,
        name: "Produttori del Barbaresco",
        image: "/assets/images/bottle-1.webp",
        thumbs: [
            "/assets/images/product-01.jpg",
            "/assets/images/product-detail-02.jpg",
            "/assets/images/product-detail-03.jpg"
        ],
        price: 16.64,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L", "1L", "1.5L"
        ],
        color: [
            "Red", "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg
            Dimensions 110 x 33 x 100 cm
            Materials 60% cotton
            Color Black, Blue, Grey, Green, Red, White
            Size XL, L, M, S
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
    {
        id: 6,
        name: "del Poggio Moscato d\"Asti",
        image: "/assets/images/bottle-2.webp",
        thumbs: [
            "/assets/images/product-02.jpg",
            "/assets/images/product-detail-05.jpg",
            "/assets/images/product-detail-06.jpg"
        ],
        price: 8.12,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L"
        ],
        color: [
            "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg
            Dimensions 110 x 33 x 100 cm
            Materials 60% cotton
            Color Black, Blue, Grey, Green, Red, White
            Size XL, L, M, S
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
    {
        id: 7,
        name: "Cantina Beato Bartolomeo Pinot",
        image: "/assets/images/bottle-3.webp",
        thumbs: [
            "/assets/images/product-03.jpg",
            "/assets/images/product-detail-01.jpg",
            "/assets/images/product-detail-02.jpg"
        ],
        price: 16.64,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L", "1L"
        ],
        color: [
            "Red", "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg
            Dimensions 110 x 33 x 100 cm
            Materials 60% cotton
            Color Black, Blue, Grey, Green, Red, White
            Size XL, L, M, S
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
    {
        id: 8,
        name: "Bouvet Saphir 2018",
        image: "/assets/images/bottle-4.webp",
        thumbs: [
            "/assets/images/product-04.jpg",
            "/assets/images/product-detail-02.jpg",
            "/assets/images/product-detail-03.jpg"
        ],
        price: 16.64,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L", "1L", "2L"
        ],
        color: [
            "Red", "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg
            Dimensions 110 x 33 x 100 cm
            Materials 60% cotton
            Color Black, Blue, Grey, Green, Red, White
            Size XL, L, M, S
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
    {
        id: 9,
        name: "Bouvet Saphir 2018",
        image: "/assets/images/bottle-4.webp",
        thumbs: [
            "/assets/images/product-04.jpg",
            "/assets/images/product-detail-02.jpg",
            "/assets/images/product-detail-03.jpg"
        ],
        price: 16.64,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L", "1L", "2L"
        ],
        color: [
            "Red", "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg
            Dimensions 110 x 33 x 100 cm
            Materials 60% cotton
            Color Black, Blue, Grey, Green, Red, White
            Size XL, L, M, S
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
    {
        id: 10,
        name: "Bouvet Saphir 2018",
        image: "/assets/images/bottle-4.webp",
        thumbs: [
            "/assets/images/product-04.jpg",
            "/assets/images/product-detail-02.jpg",
            "/assets/images/product-detail-03.jpg"
        ],
        price: 16.64,
        info: "Mehsul haqqinda daha etrafli melumat burada eks olunur.",
        size: [
            "0.5L", "0.7L", "1L", "2L"
        ],
        color: [
            "Red", "Blue", "White", "Grey"
        ],
        description: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc. ",
        advancedInfo: `
            Weight 0.79 kg <br />
            Dimensions 110 x 33 x 100 cm <br />
            Materials 60% cotton <br />
            Color Black, Blue, Grey, Green, Red, White <br />
            Size XL, L, M, S <br />
        `,
        review: [
            {
                name: "Ariana Grande",
                image: "/assets/images/avatar-01.jpg",
                message: "Quod autem in homine praestantissimum atque optimum est, id deseruit. Apud ceteros autem philosophos",
                rating: "2.5"
            },
            {
                name: "Ariana Grande 2",
                image: "/assets/images/avatar-01.jpg",
                message: "Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. ",
                rating: "4"
            },
        ]
    },
];